import React from 'react';
import Head from 'next/head';
import AuthFooter from './AuthFooter';

interface AuthLayoutProps {
  title: string;
  children: React.ReactNode;
  showFooter?: boolean;
  onBack?: () => void;
  backLabel?: string;
}

export default function AuthLayout({ title, children, showFooter = true, onBack, backLabel }: AuthLayoutProps) {
  return (
    <>
      <Head>
        <title>{title} - Consultorio 4.0</title>
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
      </Head>
      <div className="auth-page tw-min-h-screen tw-m-0 tw-p-5 tw-flex tw-justify-center tw-items-center tw-font-sans">
        <div className="tw-flex tw-justify-center tw-w-full tw-p-5">
          <div className="tw-bg-white tw-py-10 tw-px-9 tw-rounded-2xl tw-shadow-2xl tw-w-[440px] tw-max-w-[95%] tw-text-center tw-transition-all tw-duration-300 tw-relative hover:-tw-translate-y-0.5">
            {onBack && (
              <button
                type="button"
                className="tw-absolute tw-top-4 tw-left-4 tw-bg-transparent tw-border-none tw-text-gray-400 tw-text-xs tw-cursor-pointer tw-flex tw-items-center tw-gap-1 tw-py-1 tw-px-1.5 tw-rounded tw-transition-colors tw-duration-200 hover:tw-text-gray-600 hover:tw-bg-gray-50"
                onClick={onBack}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
                {backLabel || 'Indietro'}
              </button>
            )}
            <h2 className="tw-text-2xl tw-font-bold tw-mb-6 tw-text-[#001F3F]">{title}</h2>
            {children}
            {showFooter && <AuthFooter />}
          </div>
        </div>

        <style jsx>{`
          .auth-page {
            background: linear-gradient(270deg, #001F3F, #002A5C, #001F3F);
            background-size: 600% 600%;
            animation: gradientAnimation 15s ease infinite;
          }

          @keyframes gradientAnimation {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}</style>
      </div>
    </>
  );
}
